module.exports = __webpack_public_path__ + "static/retargeting-f2d5dd94a66b61b2fb8c04c6cb49a51f.png";